var _a;
import { __decorate, __metadata, __param } from "tslib";
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { ExportApi } from './apis/export-api.interface';
import _ from 'lodash';
let ExportRepositoryImpl = class ExportRepositoryImpl {
    constructor(_exportApi) {
        this._exportApi = _exportApi;
    }
    getExportQueryId(params) {
        const data = {
            ..._.pick(params, ['type', 'sort', 'qid', 'efqid', 'comment', 'mode', 'count', 'start', 'end']),
            'workspace_id': params.workspaceId,
            'folder_id': params.folderId,
            'patent_ids': params.patentIds,
        };
        if (!data.patent_ids || data.patent_ids.length === 0) {
            delete data.patent_ids;
        }
        return this._exportApi.getExportQueryIdApi(data).then(res => res.query_id);
    }
};
ExportRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(ExportApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof ExportApi !== "undefined" && ExportApi) === "function" ? _a : Object])
], ExportRepositoryImpl);
export { ExportRepositoryImpl };
